import React from 'react';
// components
import SvgIconStyle from '../../../../components-core/SvgIconStyle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Iconify from '../../../../components-core/Iconify';
// ----------------------------------------------------------------------

const getIcon = name => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking')
};

export const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Ogólne',
    items: [
      { title: 'Zapisy', path: 'orders', icon: <Iconify icon="icon-park-outline:transaction-order"/> },
      { title: 'Formularze', path: 'form-list', icon: <Iconify icon="clarity:form-line"/> },
      { title: 'Rozrachunki', path: 'settlements', icon: ICONS.banking },
      { title: 'Kartoteki', path: 'records', icon: ICONS.booking }
      // { title: 'Powiadomienia', path: 'notifications', icon: <NotificationsIcon /> }
      // { title: 'Statystyki', path: 'statistics', icon: ICONS.analytics }
    ]
  }

];

export const guestNavConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Ogólne',
    items: [{ title: 'Raporty', path: 'getpaid-excel', icon: ICONS.analytics }]
  }

];
